import React, { Component } from 'react'
import { imageAddress } from '../../../../utils/useful'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import SidebarView from '../../../SidebarView'
import Members from '../sideBar/Members'
import StagesManager from '../../../StagesManager'
import ContactInfoFirst from './ContactInfoFirst'
import ContactMedia from './ContactMedia'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../../stores/actionsList'

class ContactInfo extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        option: [
            // { icon: "/assets/icons/manage-gray.svg", title: "Edit Contact", color: "#444", key: "manage" },
            // { icon: "/assets/icons/messenger/share-contact.svg", title: "Share Contact", color: "#444", key: "share" },
            { icon: "/assets/icons/messenger/block.svg", title: "{{lang}}messenger.Block User", color: "#E61515", key: "block" },
        ],
        contactUser: {},
        userinfo: { username: "@Gedrich98", des: "this is a test bio description that's it the rest is just a usless words just to make this test a little bit longer for testing the UI.", number: "+989021377118" },
        media: {},
        medias: [
            { name: '{{lang}}messenger.Photos', icon: "/assets/icons/camera-blue.svg", key: 'image' },
            { name: '{{lang}}messenger.Video', icon: "/assets/icons/video-blue.svg", key: 'video' },
            { name: '{{lang}}messenger.File', icon: "/assets/icons/doc-blue.svg", key: 'file' },
            { name: '{{lang}}messenger.Music', icon: "/assets/icons/music-blue.svg", key: 'music' },
            { name: '{{lang}}messenger.Voice', icon: "/assets/icons/mic-blue.svg", key: 'voice' },
            { name: '{{lang}}messenger.Links', icon: "/assets/icons/link-blue.svg", key: 'links' },
        ],
    }
    componentDidMount() {
        // console.log('pvkss', this.props.messenger)
        let medias = this.state.medias
        medias.forEach(media => {
            this.filterMedia(media.key)
        });
        this.sidebarView.openSidebar()
        let contactUser = {}
        this.props.messenger?.users.forEach(user => {
            // console.log('user mess', user)
            if (this.props.myId != user.hub._id) {
                // console.log('contactUser', user)
                // console.log(this.props.myId)
                contactUser.username = user.hub?.username
                contactUser.fullname = user.hub?.fullname
                contactUser.phone = user.hub?.phone
                contactUser.image = user.hub?.image
            }
        });
        this.setState({ contactUser })
    }

    filterMedia = (key) => {
        // console.log('messengers', this.props.messengers.messages)
        // console.log('messengers', this.props.messenger)
        let media = this.state.media
        media[key] = []
        Object.values(this.props.messengers.messages).forEach(element => {
            // console.log('keyha', element)
            element.forEach(prop => {
                // console.log('ooko', prop[key] != null)
                if (prop.messenger == this.props.messenger?._id && prop[key] != null) {
                    media[key].push(prop)
                }
            })
        });
        // console.log('media is', media[key])
        this.setState({ media })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }
    onClosed = () => {
        setTimeout(() => {
            this.props.setData('messengerInfo', !this.props.messengerInfo, 'Messenger')
        }, 200);
    }


    render() {
        let type = this.state.type
        return (
            <div className='w-100 h-100'>
                <SidebarView onClosed={this.onClosed} hight={"100%"} width={this.props.width} hideOverlay={false} ref={el => this.sidebarView = el} widthCondition={{ xs: "100%", sm: "100%", md: '25%', lg: "25%", xl: "25%" }}>
                    <div className='w-100 h-100' >
                        <StagesManager ref={el => this.stageManager = el} height={"100%"} fast={true}>
                            <ContactInfoFirst language={this.props.language} media={this.state.media} contactUser={this.state.contactUser} width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={''} colors={this.props.colors} />
                            <ContactMedia language={this.props.language} filterMedia={this.filterMedia} media={this.state.media} medias={this.state.medias} messenger={this.props.messenger} contactUser={this.state.contactUser} width={this.props.width} height={"100%"} changeStage={this.changePage} stage={1} stageName={'media'} colors={this.props.colors} />
                        </StagesManager>
                    </div>
                </SidebarView>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactInfo);